import { useState } from "react";

import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";
import LabelFileFields, { EMPTY_LABEL, LabelFields, labelFieldsComplete } from "./LabelFileFields";

/** Our own return label on an accepted return, replacing eBay's. */
export default function UploadLabelPanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  const [label, setLabel] = useState<LabelFields>(EMPTY_LABEL);

  return (
    <ActionPanelFrame
      kind="upload_label"
      detail={detail}
      title={`${t("Upload your own return label")} · ${t("optional, replaces eBay's")}`}
      canConfirm={labelFieldsComplete(label)}
      messageRequired={false}
      confirmLabel={t("Upload to eBay")}
      onConfirm={(message) => onConfirm({ message, labelSource: "own", carrier: label.carrier.trim(), tracking: label.tracking.trim(), labelFileName: label.labelFileName, labelFileBase64: label.labelFileBase64 })}
      onCancel={onCancel}
      busy={busy}
    >
      <LabelFileFields value={label} onChange={setLabel} disabled={busy} />
    </ActionPanelFrame>
  );
}
